<template>
  <global-layout >
    <div class="home">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"/>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"/>
    </div>
  </global-layout>
</template>

<script>
  import GlobalLayout from '@/components/apppad/page/GlobalLayout'
  import { mixin, mixinDevice } from '@/utils/mixin.js'
  import { triggerWindowResizeEvent } from '@/utils/util'
  const indexKey = '/pad'
  import Vue from 'vue'
  import { CACHE_INCLUDED_ROUTES } from "@/store/mutation-types"
  import { CACHE_PROJECT_ID} from '@/constants/project'
  export default {
    name: 'BaseLayouts',
    components: {
      GlobalLayout

    },
    mixins: [mixin, mixinDevice],
    data() {
      return {
        reloadFlag:true,
        lastProjectId:''
      }
    },
    provide(){
      return{
        closeCurrent:()=>{}
      }
    },
    computed: {
      exclude(){
        return []
      },
    },
    created() {
    },
    mounted() {
      if(this.$route.path !== '/pad/index'){
        // if(!this.projectId){
        //   this.$router.push({path:'/pad/index'})
        // }
      }
    },
    watch: {
      '$route': function() {
        const project = Vue.ls.get(CACHE_PROJECT_ID)
        if(this.lastProjectId!==project){
          this.reloadRoute()
          this.lastProjectId = project
        }
      },

    },
    methods: {
      reloadRoute(){
        this.reloadFlag = false
        this.$nextTick(()=>{
          this.reloadFlag = true
        })
      }
    }
  }
</script>

<style lang="less">

  /*
 * The following styles are auto-applied to elements with
 * transition="page-transition" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the page transition by editing
 * these styles.
 */

  .page-transition-enter {
    opacity: 0;
  }

  .page-transition-leave-active {
    opacity: 0;
  }

  .page-transition-enter .page-transition-container,
  .page-transition-leave-active .page-transition-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  /*美化弹出Tab样式*/
  .ant-tabs-nav-container {
    margin-top: 4px;
  }

  /* 修改 ant-tabs 样式 */
  .tab-layout-tabs.ant-tabs {
    border-bottom: 1px solid #ccc;
    border-left: 1px solid #ccc;
    background-color: white;
    padding: 0 20px;

    .ant-tabs-bar {
      margin: 4px 0 0;
      border: none;
    }

  }

  .tab-layout-tabs.ant-tabs {

    &.ant-tabs-card .ant-tabs-tab {

      padding: 0 24px !important;
      background-color: white !important;
      margin-right: 10px !important;

      .ant-tabs-close-x {
        width: 12px !important;
        height: 12px !important;
        opacity: 0 !important;
        cursor: pointer !important;
        font-size: 12px !important;
        margin: 0 !important;
        position: absolute;
        top: 36%;
        right: 6px;
      }

      &:hover .ant-tabs-close-x {
        opacity: 1 !important;
      }

    }

  }

  .tab-layout-tabs.ant-tabs.ant-tabs-card > .ant-tabs-bar {
    .ant-tabs-tab {
      border: none !important;
      border-bottom: 1px solid transparent !important;
    }
    .ant-tabs-tab-active {
      border-color: @primary-color!important;
    }
  }
  // .home{
  //   height: 100%;
  //   overflow-y: auto;
  // }

</style>
